<template>
  <div
    class="market-contracts-list-header-sushi"
    :class="{
      'market-contracts-list-header-sushi--forced-mobile': forceMobileLayout,
      'market-contracts-list-header-sushi--cms-widget': forCmsWidget,
      'market-contracts-list-header-sushi--dashboard': dashboardMode && !forCmsWidget,
    }"
  >
    <template v-if="useMobileLayout">
      <div v-if="forCmsWidget" class="market-contracts-list-header-sushi--cms-mobile">
        <div class="market-contracts-list-header-sushi__item-1">
          {{ titleFirst }}
        </div>
        <div class="market-contracts-list-header-sushi__item-2">
          <div class="market-contracts-list-header-sushi__item-2-text">
            {{ titleSecond }}
          </div>
        </div>
      </div>
      <div v-else :class="mobileBarClassModifiers">
        <market-settings-button theme="details" v-model="showSettingsModal" />
        <div class="market-contracts-list-header-sushi__mobile-title" v-if="!isMarketDisabled">
          {{ titleSecond }}
        </div>
      </div>
    </template>
    <template v-else>
      <div class="market-contracts-list-header-sushi__item-1">
        {{ titleFirst }}
      </div>

      <!-- Dashboard: flex wrapper for space-between column alignment -->
      <div v-if="dashboardMode" class="market-contracts-list-header-sushi__middle-columns">
        <template v-if="!forCmsWidget">
          <div class="market-contracts-list-header-sushi__item-type">{{ titleType }}</div>
        </template>
        <market-contracts-list-header-sushi-item2
          :title="titleSecond"
          :for-cms-widget="forCmsWidget"
        />
        <template v-if="!forCmsWidget">
          <div class="market-contracts-list-header-sushi__item-3">{{ titleThird }}</div>
          <div class="market-contracts-list-header-sushi__item-4">{{ titleFourth }}</div>
          <div class="market-contracts-list-header-sushi__item-buy-orders">
            {{ titleBuyOrders }}
          </div>
          <div class="market-contracts-list-header-sushi__item-sell-orders">
            {{ titleSellOrders }}
          </div>
        </template>
      </div>

      <!-- Non-dashboard: items as direct flex children of header -->
      <template v-else>
        <market-contracts-list-header-sushi-item2
          :title="titleSecond"
          :for-cms-widget="forCmsWidget"
        />
        <template v-if="!forCmsWidget">
          <div class="market-contracts-list-header-sushi__item-3">{{ titleThird }}</div>
          <div class="market-contracts-list-header-sushi__item-4">{{ titleFourth }}</div>
          <div class="market-contracts-list-header-sushi__item-5">{{ titleFifth }}</div>
        </template>
      </template>

      <div class="market-contracts-list-header-sushi__item-6">
        <market-settings-button v-if="!forCmsWidget" v-model="showSettingsModal" />
      </div>
    </template>
    <market-settings-modal v-if="!forCmsWidget" v-model="showSettingsModal" />
  </div>
</template>

<script src="./market-contracts-list-header-sushi.js"></script>
<style src="./market-contracts-list-header-sushi.scss" lang="scss"></style>
